export const LOAD_LAZY_COMPONENT = 'LOAD_LAZY_COMPONENT';

export const loadLazyComponent = componentKey => ({
    type: LOAD_LAZY_COMPONENT,
    componentKey,
});
